import { MatchService } from "../services/api/eslapi/MatchService";

export class MatchListController {
    public limitByStatus: any = {};
    public matchlist: any = {};
    public leagueId: number;
    public limit: number;
    public maxClosed: number;
    public maxOpen: number;
    public maxChallenge: number;
    public maxProtest: number;
    public maxAgeClosed: number;

    public static $inject = ["MatchServiceOld"];
    constructor(private MatchServiceOld: MatchService) {}

    public $onChanges() {
        this.limitByStatus = {
            closed: this.maxClosed,
            open: this.maxOpen,
            challenge: this.maxChallenge,
            protest: this.maxProtest,
        };

        this.MatchServiceOld.getMatches(this.leagueId, this.limit, this.limitByStatus, this.maxAgeClosed).then(data => {
            this.matchlist = data;
        });
    }
}

export class MatchItemController {
    public id: number;
    public data: any;

    public static $inject = ["MatchServiceOld"];
    constructor(private MatchServiceOld: MatchService) {}

    public $onChanges() {
        this.MatchServiceOld.getMatch(this.id).then(matchData => {
            this.data = matchData;
        });
    }

    public hasWinner() {
        return this.hasResult();
    }

    public hasLooser() {
        return this.hasResult();
    }

    public getMatchContestantByResult(type) {
        let contestants = this.getContestants(),
            contestantType = "user";

        if (this.data.type === "team") {
            contestantType = "team";
        }

        if (type == "looser") {
            // The first contestant has lost
            if (this.data.result.score[contestants[0][contestantType].id] < this.data.result.score[contestants[1][contestantType].id]) {
                return contestants[0];
            }

            // The second contestant has lost
            if (this.data.result.score[contestants[1][contestantType].id] < this.data.result.score[contestants[0][contestantType].id]) {
                return contestants[1];
            }
        } else if (type === "winner") {
            // The first contestant has won
            if (this.data.result.score[contestants[0][contestantType].id] > this.data.result.score[contestants[1][contestantType].id]) {
                return contestants[0];
            }

            // The second contestant has won
            if (this.data.result.score[contestants[1][contestantType].id] > this.data.result.score[contestants[0][contestantType].id]) {
                return contestants[1];
            }
        }

        return undefined;
    }

    public getWinner() {
        if (this.hasWinner()) {
            return this.getMatchContestantByResult("winner");
        }

        return undefined;
    }

    public getLooser() {
        if (this.hasLooser()) {
            return this.getMatchContestantByResult("looser");
        }

        return undefined;
    }

    public hasResult() {
        if (this.data.status === "closed") {
            return typeof this.getMatchContestantByResult("winner") !== "undefined";
        }

        return false;
    }

    public getContestants() {
        return this.data.contestants;
    }

    public getContestantResult(contestant) {
        let contestantId,
            roundsByContestant = [],
            idx;

        if (this.data.type == "team") {
            contestantId = contestant.team.id;
        } else {
            contestantId = contestant.user.id;
        }

        for (idx in this.data.result.rounds) {
            if (this.data.result.rounds.hasOwnProperty(idx) && this.data.result.rounds[idx].hasOwnProperty(contestantId)) {
                roundsByContestant.push(this.data.result.rounds[idx][contestantId]);
            }
        }

        return {
            points: this.data.result.points[contestantId],
            score: this.data.result.score[contestantId],
            rounds: roundsByContestant,
        };
    }

    public getFirstContestantResult() {
        return this.getContestantResult(this.getFirstContestant());
    }

    public getSecondContestantResult() {
        return this.getContestantResult(this.getSecondContestant());
    }

    public getFirstContestant() {
        let contestants = this.getContestants();
        return contestants[0];
    }

    public getSecondContestant() {
        let contestants = this.getContestants();
        return contestants[1];
    }
}
